import getByUseItWithVariantIdsProductSelector from 'modules/product/redux/selectors/get-by-perfect-your-look-variant-ids'
import compactArrayUtil from 'utils/array/compact'

const isLoadedQuickShopProductSidebarUseItWithSelector = perfectYourLookVariantList => (state) => {
  const perfectYourLookVariants = getByUseItWithVariantIdsProductSelector(perfectYourLookVariantList)(state)
  return compactArrayUtil(perfectYourLookVariants)?.length === perfectYourLookVariantList.length
}

export default isLoadedQuickShopProductSidebarUseItWithSelector
